// src/locales/en.js
export default {
  // ============================================================
  // TITLES AND MAIN TEXTS
  // ============================================================
  title: 'STRATIUM GLOBAL AI',
  subtitle: 'Cost Optimization Specialist & AI Financial Auditor',
  
  // ============================================================
  // PLANS AND PRICES
  // ============================================================
  planStarter: 'Starter',
  planPro: 'Pro',
  planBusiness: 'Business',
  planElite: 'Elite',
  planStarterPrice: '$0 / 15 days',
  planProPrice: '$29.99/mo',
  planBusinessPrice: '$79.99/mo',
  planElitePrice: '$199.99/mo',
  planStarterPriceUSD: '$0 / 15 days',
  planProPriceUSD: '$29.99/mo',
  planBusinessPriceUSD: '$79.99/mo',
  planElitePriceUSD: '$199.99/mo',
  scans: 'Scans',
  days: 'Days',
  capitalInjected: 'Injected Capital',
  
  // ============================================================
  // BUTTONS AND ACTIONS
  // ============================================================
  audit: 'Audit',
  exportCSV: 'Export CSV',
  attach: 'Attach',
  attaching: 'Attaching...',
  scanInvoice: 'Scan Invoice',
  processingOCR: 'Processing OCR...',
  viewLogs: 'View Logs',
  logout: 'Logout',
  connecting: 'Connecting...',
  online: 'Online',
  generating: 'Generating...',
  report: 'Report',
  analyze: 'Analyze',
  pdfReport: 'PDF Report',
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  configure: 'Configure',
  upgrade: 'Upgrade',
  upgradeToCompare: 'Upgrade to compare',
  pagar: 'Pay',
  comprar: 'Buy',
  saving: 'Saving...',
  
  // ============================================================
  // DASHBOARD AND KPIS
  // ============================================================
  sales: 'Sales',
  profit: 'Profit',
  margin: 'Margin',
  balance: 'Cash Balance',
  salesVariation: 'vs last month',
  netPeriod: 'Period net',
  onSales: 'On sales',
  historicalBalance: 'Historical balance',
  positive: 'Positive',
  negative: 'Negative',
  cashRunway: 'Cash runway',
  healthThermometer: 'Health Thermometer',
  incomeVsExpenses: 'Income vs Expenses',
  financialAlerts: 'Financial Alerts',
  strategicRecommendations: 'Strategic Recommendations',
  alerts: '🚨 Financial Sergeant Alerts',
  expenses: 'Expenses',
  purchases: 'Purchases',
  capital: 'Capital',
  currentPeriod: 'Current period',
  
  // ============================================================
  // PRODUCTION
  // ============================================================
  productionOrder: '🏭 Production Order v2.4-International',
  productionSubtitle: 'Financial precision with effort-based prorating and installed capacity',
  totalBatchHours: 'Total Batch Hours',
  exampleHours: 'Ex: 40',
  hourlyRateValue: 'Hourly Rate ($)',
  transportLogistics: 'Transport/Logistics ($)',
  additionalExpenses: 'Additional Expenses ($)',
  batchItems: '📦 Batch Items (with hourly effort)',
  addItem: '+ Add Item',
  product: 'Product',
  quantity: 'Qty',
  price: 'Price',
  materialsPerUnit: 'Materials/Unit',
  delete: '🗑️',
  auditFullBatch: '🔍 Audit Full Batch (v2.4-International)',
  footerText1: 'Stratium GLOBAL AI v2.4-International • CO • EN',
  footerText2: 'Labor factor: 1.52x • Commission: 27.1% • Provision: $10,000/unit',
  footerText3: 'Smart financial auditing for real entrepreneurs',
  productionAudit: 'Production Audit',
  loadingAuditEngine: 'Loading audit engine...',
  hoursPerUnit: 'Hours/Unit',
  estimatedHours: 'Estimated hours per unit',
  risk: 'RISK',
  optimal: 'OPTIMAL',
  profitable: 'PROFITABLE',
  totalVariableCost: 'Total Var. Cost',
  costIncludes: 'Includes: Materials + Commission 27.1% + Labor',
  provision: 'Provision',
  auditedProfit: 'Audited Profit',
  profitDescription: 'Net profit after all variable costs + $10,000 provision for monthly fixed expenses.',
  auditedMargin: 'Audited Margin',
  breakEvenPoint: 'Break-even Point',
  laborPerUnit: 'Labor/Unit (Audit.)',
  cifPerUnit: 'CIF/Unit',
  channelCommission: 'Channel Commission',
  priceSimulator: 'Price Simulator for 10-40% Margins',
  forMargin: 'For',
  increase: 'Increase',
  decrease: 'Decrease',
  current: 'Current',
  totalContribution: 'Total contribution',
  installedCapacity: 'Installed Capacity - Fixed Cost Absorption',
  monthlyFixedExpenses: 'Monthly Fixed Expenses',
  accumulatedAbsorption: 'Accumulated Absorption (month)',
  currentLotContribution: 'Current Lot Contribution',
  totalProjected: 'Total Projected',
  covered: 'covered',
  remainingToCover: 'Remaining to cover',
  toCoverFixedCosts: 'to cover monthly fixed costs',
  fixedCostsCovered: 'Monthly fixed costs fully covered',
  auditing: 'Auditing with precision...',
  registering: 'Registering in financial blockchain...',
  negativeMarginWarning: 'Some products have negative margin. Would you like to review them before saving?',
  registerLot: 'Register Lot with Full Traceability',
  
  // ============================================================
  // AUDIT CONFIGURATION
  // ============================================================
  auditConfigTitle: '⚙️ Audit Configuration',
  auditConfigSubtitle: 'Define your business financial parameters for an accurate audit',
  operationRegion: 'Operating Region',
  southAmerica: 'South America',
  monthlyFixedCosts: 'Monthly Fixed Expenses',
  fixedCostsPlaceholder: 'Rent + Utilities + Admin Salary + Software + Marketing',
  mainSalesPlatform: 'Main Sales Platform',
  ownPlatform: 'OWN PLATFORM',
  saveConfig: 'Save Configuration',
  closeConfig: 'Close',
  configuracionAuditoria: 'Audit Configuration',
  configurar: 'Configure',
  region: 'Region',
  gastosFijos: 'Monthly Fixed Expenses',
  plataforma: 'Main selling platform',
  guardar: 'Save Configuration',
  fixedCostsRequired: '⚠️ Monthly fixed expenses are required',
  configSaved: '✅ Configuration saved successfully',
  configError: '❌ Error saving configuration',
  selectorPais: 'Select your country',
  saveConfiguration: 'Save configuration',
  
  // ============================================================
  // HEALTH AND STATUS
  // ============================================================
  healthExcellent: 'Excellent',
  healthStable: 'Stable',
  healthCritical: 'Critical',
  noData: 'No data',
  viewFullHistory: 'View full history',
  totalTransactions: 'transactions',
  
  // ============================================================
  // SLEEP INDICATOR (DAYS COVERED)
  // ============================================================
  daysCovered: '{dias}/{total} days',
  sleepIndicator: '😴 Days of expenses covered',
  sleepIndicatorAria: 'Days covered indicator',
  mensajeSueñoExcelente: '🎉 Excellent. Your monthly fixed expenses are already covered.',
  mensajeSueñoBueno: 'You need {dias} more days to cover fixed expenses.',
  mensajeSueñoRegular: 'You cover {dias} days of fixed expenses.',
  mensajeSueñoCritico: '🚨 You have not generated enough profit to cover fixed expenses.',
  mensajeSinDatos: 'Record your fixed expenses and sales to see how many days you cover.',
  coveredLabel: 'Covered:',
  missingLabel: 'Missing:',
  tooltipAuditedProfit: 'Net profit = Sales - Variable costs. Fixed costs are subtracted here to calculate days covered.',
  
  // ============================================================
  // TRUST METER (CONFIDENCE LEVEL)
  // ============================================================
  auditTrustLevel: '📊 Audit Trust Level',
  trustMessageLow: '💡📝 Record your daily sales and expenses to get real business insights',
  lowConfidence: 'Low confidence',
  mediumConfidence: 'Medium confidence',
  highConfidence: 'High confidence',
  
  // ============================================================
  // USER GREETING
  // ============================================================
  goodEvening: 'Good evening',
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  from: 'from',
  letsTakeCare: '🇨🇴 Let\'s take care of your business!',
  regionLabel: '🌐 Region',
  currencyLabel: '💱 Currency',
  localTime: 'Local time',
  
  // ============================================================
  // MANUAL TRANSACTION
  // ============================================================
  tituloRegistroManual: 'Manual Transaction Entry',
  tipoMovimiento: 'Transaction type',
  gasto: 'Expense',
  ingreso: 'Income',
  compraInventario: 'Purchase (inventory)',
  venta: 'Sale',
  fuentePago: 'Paid with...',
  fuenteNegocio: '💰 Business funds',
  fuentePersonal: '👤 Personal funds (Capital injection)',
  montoTotal: 'Total Amount',
  fecha: 'Date',
  tercero: 'Supplier / Customer',
  tipoPago: 'Payment type',
  contado: '💰 Cash',
  credito: '📅 Credit',
  fechaLimitePago: 'Payment deadline',
  fechaVencimientoProducto: 'Product expiration date',
  ejemploConcepto: 'Type the product name...',
  guardar: 'Register Transaction',
  guardando: 'Saving...',
  exito: '✅ Transaction recorded successfully',
  advertenciaPersonal: '⚠️ You are injecting personal capital into the business. This creates a debt from the business to you.',
  saldoInsuficiente: '❌ Cannot register this expense. Insufficient balance. Available: {saldo}. Needed: {monto}.',
  stockInsuficiente: '❌ Cannot register sale. Insufficient stock. Available: {stock} units. Requested: {solicitado} units.',
  productosCriticos: '🦴 Critical Products (BONE)',
  productosEstrella: '⭐ Star Products',
  sinProductosCriticos: '✅ No BONE products in inventory',
  sinProductosEstrella: '⚠️ No star products yet',
  infoProducto: '📊 Product Information',
  clasificacion: 'Classification',
  diasSinVentas: 'Days without sales',
  margen: 'Margin',
  precioLiquidacion: 'Suggested liquidation price',
  estrategia: 'Strategy',
  liquidacionPerdida: '💀 CONTROLLED LOSS',
  recuperarCapital: '💰 RECOVER CAPITAL',
  alCosto: '📦 AT COST',
  promocionLigera: '🔥 LIGHT PROMOTION',
  urgencia180: '⚠️ URGENT: over 180 days',
  urgencia90: '⚠️ Alert: over 90 days',
  urgencia60: '⚡ Recover investment',
  urgencia30: '💡 Free up cash flow',
  precioSugerido: '💰 Suggested',
  diasSinRotacion: 'days without rotation',
  montoInvalido: '❌ Amount must be greater than zero',
  errorGeneral: 'Error',
  aportePersonalRecomendacion: '💰 Personal capital injection. The business owes you this money.',
  dejarBlanco: 'Leave blank if not applicable',
  
  // ============================================================
  // INVOICE VALIDATION
  // ============================================================
  validarFactura: '📄 Validate Invoice',
  proveedor: 'Supplier',
  total: 'Total',
  impuestos: 'Tax',
  inventario: '📦 Inventory',
  gastos: '📋 Expenses',
  personal: '👤 Personal',
  ivaTotal: '💰 Total Tax',
  ivaEditable: '💡 Tax is editable. If the value is incorrect, you can modify it.',
  sinProductos: 'No products detected in the invoice',
  alertaPersonal: '⚠️ Detected {monto} in personal expenses. This does not affect your business but affects your cash flow.',
  confirmar: 'Confirm & Save',
  
  // ============================================================
  // ONBOARDING AND TOUR
  // ============================================================
  onboardingWelcome: '👋 Hi, I\'ll help you know if your business makes money.',
  onboardingQuestion: 'How do you manage your business today?',
  notebook: '📒 Notebook or paper',
  excelSoftware: '💻 Excel or software',
  accountingSoftware: '📊 Accounting software',
  noControl: '📭 I don\'t track it',
  onboardingDone: 'Done! With this data I can show you something useful.',
  
  // ============================================================
  // TOOLTIPS
  // ============================================================
  tooltipSales: 'Total sales revenue for the current month',
  tooltipProfit: 'Revenue minus expenses for the period',
  tooltipMargin: 'Profit percentage over sales',
  tooltipBalance: 'Historical accumulated balance (income - expenses)',
  tooltipCashRunway: 'Days you can operate with current balance without new income',
  tooltipBoneProduct: 'Product with no sales for over 15 days - recommendation: discount liquidation',
  tooltipLowMargin: 'Margin below 20% - risk in dropshipping if returns occur',
  tooltipStarProduct: 'Product with highest revenue in the period',
  tooltipBankruptcy: 'Cash flow alert - immediate action required',
  tooltipHealth: 'Financial health indicator based on net margin',
  tooltipThermometer: 'Health bar: >30% Excellent, 15-30% Stable, <15% Critical',
  
  // ============================================================
  // ALERTS AND MESSAGES
  // ============================================================
  outlierAlert: '⚠️ Unusual expense detected',
  outlierAlertDesc: 'This expense significantly exceeds your average. Is it correct?',
  inconsistencyAlert: '⚠️ Balance inconsistency detected',
  inconsistencyAlertDesc: 'Calculated balance does not match the sum of transactions. Review your records.',
  belowBreakEven: 'Below break-even point',
  marginDrop: 'Margin drop',
  noCriticalAlerts: 'No critical alerts. Business flowing as planned.',
  bankruptcyAlert: '🔥 BANKRUPTCY ALERT',
  noSalesAlert: '📢 You haven\'t recorded sales yet. Activate your commercial strategy to start generating revenue.',
  
  // ============================================================
  // GROWTH AND BREAK-EVEN
  // ============================================================
  growth: 'Growth',
  decline: 'Decline',
  breakEvenPointTitle: 'Break-even Point',
  breakEvenDesc: 'Sales needed to cover fixed costs',
  alertBreakEven: '⚠️ You are below break-even point. Need more sales to cover fixed costs.',
  
  // ============================================================
  // LOGIN AND AUTHENTICATION
  // ============================================================
  loginTitle: 'Welcome to STRATIUM GLOBAL AI',
  loginSubtitle: 'Your AI Financial Assistant',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  nombre: 'Name (optional)',
  login: 'Sign In',
  register: 'Sign Up',
  noAccount: "Don't have an account?",
  hasAccount: 'Already have an account?',
  switchToRegister: 'Sign up here',
  switchToLogin: 'Sign in here',
  plan: 'Plan',
  gratis: 'Free (15 days)',
  pro: 'Pro',
  business: 'Business',
  elite: 'Elite',
  loadingAuth: 'Loading authentication...',
  errorAuth: 'Authentication error',
  showPassword: 'Show',
  hidePassword: 'Hide',
  passwordsDontMatch: 'Passwords do not match',
  
  // ============================================================
  // UPGRADE MODAL
  // ============================================================
  upgradeTitle: 'Feature not available',
  upgradeDescription: 'is exclusive to paid plans',
  upgradePro: 'Pro',
  upgradeBusiness: 'Business',
  upgradeElite: 'Elite',
  upgradeButton: 'View Plans and Pricing',
  starterPlan: '15-day Trial',
  plan1: 'Pro',
  plan2: 'Business',
  plan3: 'Elite',
  
  // ============================================================
  // SCAN PACKAGES
  // ============================================================
  masPopular: 'Most popular',
  paquetesEscaneos: 'ADDITIONAL SCAN PACKAGES',
  paqueteBasico: 'Basic',
  paqueteFrecuente: 'Frequent',
  paqueteProfesional: 'Professional',
  paqueteCorporativo: 'Corporate',
  paquetesNota: 'Packages are purchased inside the app and NOT included in the monthly plan',
  creditPackages: 'ADDITIONAL CREDITS FOR AI SUPPORT',
  consultasIA: 'AI queries',
  creditosNota: '💡 Credits add to your current plan and DO NOT expire monthly.',
  
  // ============================================================
  // PLANS (DETAILS)
  // ============================================================
  plansStarterTagline: 'Pocket financial advisor',
  plansStarterFeature1: '10 scans/month',
  plansStarterFeature2: 'Manual transaction entry',
  plansStarterFeature3: 'Basic financial dashboard',
  plansStarterFeature4: 'Risk alerts',
  plansStarterFeature5: 'AI support 20 messages/month',
  plansStarterFeature6: 'No PDF reports',
  plansStarterFeature7: 'No CSV export',
  
  plansProTagline: 'Smart digitization',
  plansProFeature1: '30 scans/month',
  plansProFeature2: 'Unlimited manual entry',
  plansProFeature3: 'Complete PDF reports',
  plansProFeature4: 'CSV export',
  plansProFeature5: 'Monthly comparison',
  plansProFeature6: 'Break-even point',
  plansProFeature7: 'Inventory turnover',
  plansProFeature8: 'AI support 50 messages/month',
  
  plansBusinessTagline: 'Overcost audit',
  plansBusinessFeature1: '120 scans/month',
  plansBusinessFeature2: 'Everything in Pro',
  plansBusinessFeature3: 'Forensic expense audit',
  plansBusinessFeature4: 'Supplier overcost detection',
  plansBusinessFeature5: '3 users included',
  plansBusinessFeature6: 'Deletion history',
  plansBusinessFeature7: 'AI support 200 messages/month',
  
  plansEliteTagline: 'Bankruptcy radar',
  plansEliteFeature1: '300 scans/month',
  plansEliteFeature2: 'Everything in Business',
  plansEliteFeature3: 'Bankruptcy radar (90 days)',
  plansEliteFeature4: 'Predictive WhatsApp alerts',
  plansEliteFeature5: 'Financial Health Certificate (QR)',
  plansEliteFeature6: '10 users included',
  plansEliteFeature7: 'AI support 500 messages/month',
  
  // ============================================================
  // OCR AND FILES
  // ============================================================
  procesandoOCR: 'Processing invoice with OCR...',
  escanearFactura: 'Scan invoice',
  
  // ============================================================
  // TERMS AND CONDITIONS
  // ============================================================
  aceptarTerminos: 'I accept the Terms and Conditions and authorize the processing of my personal data.',
  terminosLink: 'Terms and Conditions',
  
  // ============================================================
  // EXPIRATION DATE
  // ============================================================
  preguntarVencimiento: 'Add expiration date?',
  fechaVencimiento: 'Expiration date',
  guardarConVencimiento: 'Save with expiration',
  saltarVencimiento: 'Skip (no expiration)',
  producto: 'Product',
  
  // ============================================================
  // MY CURRENT PLAN SECTION
  // ============================================================
  miPlanActual: 'My Current Plan',
  gestionaSuscripcion: 'Manage your subscription',
  cambiarPlan: 'Change Plan',
  escaneos: 'Scans',
  dias: 'Days',
  capitalInyectado: 'Injected Capital',
  
  // ============================================================
  // FOOTER AND METADATA
  // ============================================================
  realtimeData: 'Real-time data updated from Firebase',
  autoMonthlyClose: 'Automatic monthly close on the 1st',
  
  // ============================================================
  // RECORDS AND REPORTS
  // ============================================================
  registros: 'Financial Records',
  dictamen: 'Audit Report',
  produccion: 'Production Costing',
  registroManual: 'Manual Transaction Entry',
  manualTransactionEntry: 'Manual Transaction Entry',
  financialRecords: 'Financial Records',
  auditReport: 'Audit Report',

  // ============================================================
  // KEYS FOR DASHBOARD INSIGHTS (ADD)
  // ============================================================
  boneProducts: '🦴 Dead Stock',
  noBoneProducts: 'No dead stock in inventory',
  salesTrend: '📈 Sales Trend',
  thisWeek: 'This week',
  vsLastWeek: 'vs last week',
  alertaCajaCritica: '🚨 ALERT! Your balance covers only {dias} days. Immediate action needed.',
  alertaCajaBaja: '⚠️ Your balance covers only {dias} days. Need ${monto} to reach 5 days.',
  alertaMargenBajo: '📉 Your net margin is {margen}%. Below the recommended 15%. Review your costs.',
  alertaInactividad: '📢 You haven\'t recorded transactions for {dias} days.',
  mensajePositivo: '✅ Everything is in order. Keep it up to maintain a healthy business.',
  starProducts: '⭐ Top Performers',
  noStarProducts: 'No top performers yet. Record more sales.',
  starProductsTip: '⭐ Your top performer is "{producto}". Allocate marketing budget.',
  boneProductsTip: '🦴 You have {cantidad} products without rotation. Review prices.',
  lowMarginTip: '💰 Your margins are low. Review costs or selling prices.',
  positiveMessage: '✅ Everything is going well. Keep it up.',
  noSalesAlert: '📢 You haven\'t recorded sales yet. Activate your commercial strategy to start generating revenue.',
  
  // ============================================================
  // CORRECTED FINANCIAL TERMS
  // ============================================================
  grossMargin: 'Gross Margin',
  cashBalance: 'Cash Balance',
  cashOnHand: 'Cash on Hand',
  deadStock: 'Dead Stock',
  topPerformers: 'Top Performers',
  businessFunds: '💰 Business funds',
  personalFunds: '👤 Personal funds',
  
  // ============================================================
  // CHART LEGEND
  // ============================================================
  salesLegend: 'Sales',
  expensesLegend: 'Expenses',
  purchasesLegend: 'Purchases',
  capitalLegend: 'Capital',
  profitLegend: 'Profit',

"critical_products_title": "⚠️ Critical Products (Low Rotation / Bankruptcy Risk)",
"no_critical_products": "✅ No stagnant products in inventory. Flow is optimal.",
productDetail: "Product Detail",
batchQuantity: "Batch Quantity",
totalMfgHours: "Total Mfg Hours", 
estimatedSellingPrice: "Estimated Selling Price",
materialCostPerBatch: "Material Cost per Batch",
hoursPlaceholder: "Hours",
materialsPlaceholder: "Total materials",
totalHoursTooltip: "Total hours to manufacture this product",
totalMaterialsTooltip: "Total material cost for this product batch",
suggestedStrategy: "SUGGESTED STRATEGY:",
ideal50: "Ideal (50%)",
phase30_40: "30 days (40%)",
phase60_30: "60 days (30%)",
phase90_10: "90 days (10%)",
projectedDays: "projected coverage days",
upgradeToBusiness: "Business/Elite",
upgradeToContinue: "Renew to continue",

// ============================================================
// DASHBOARD INSIGHTS ALERTS (AGREGADAS PARA INGLÉS)
// ============================================================
cashCoverageBelowTarget: "Cash coverage below your plan's target ({days} days)",
daysWithoutRecords: "{days} days without recording operations in the system",
netMarginBelowRecommended: "Net margin ({margin}%) below the recommended minimum (15%)",
priorityOne: "Priority 1: Manage overdue invoices or launch a liquid cash offer",
noSalesYet: "You haven't recorded sales yet. Activate your commercial strategy to start generating revenue.",
boostProduct: "Boost product: \"{product}\". It's your biggest cash flow generator.",
boneLiquidate: "Bone: You have {count} references without rotation. Liquidate them at cost to recover cash.",
marginsAreLow: "Your margins are low. Review costs or selling prices.",
indicatorsUnderControl: "✅ Operational indicators under control.",
salesTrendUp: "Sales trend up",
salesTrendDown: "Sales trend down",
daysCoveredGoal: "days coverage goal",
availableToday: "Available today",
planTarget: "Plan target",
sargentDiagnostic: "🚨 Financial Sergeant Diagnostic",
recommendedAction: "💡 Recommended Action",
salesTrendText: "📈 Sales Trend",
thisWeekSales: "This week",
vsLastWeekSales: "vs last week",
forgotPassword: "Forgot your password?",
resendVerification: "📧 Resend verification email",
hasAccount: "Already have an account?",
noAccount: "Don't have an account?",
switchToLogin: "Sign in here",
switchToRegister: "Sign up here",

  // ============================================================
  // MISC
  // ============================================================
  ejemplo: 'Ex: "Buy 10 caps for 125,000" or "Generate: Report"',
  verHistorial: 'View full history',
  variacionVentas: 'vs last month',
  crecimiento: 'Growth',
  decrecimiento: 'Decline',
  conectar: 'Connecting...',
  enLinea: 'Online',
  adjuntando: 'Uploading...',
  generando: 'Generating...',
  idioma: 'Language',
  español: 'Spanish',
  ingles: 'English',
  calcular: 'Calculating...',
  cargarInventario: 'Add to Inventory',
  oxigeno: 'Cash runway',
  salud: 'Health Thermometer',
  ingresosVsEgresos: 'Income vs Expenses',
  configurarAuditoria: 'Configure',
  verLogsEliminaciones: 'View deletion history',
  cerrar: 'Close',
  pago_exitoso: '✅ Payment successful. Your plan has been updated.',
  error_pago: 'Payment error',

    // ============================================================
  // RETURNS AND REFUNDS
  // ============================================================
  devolucionVenta: '⬅️ Sales Return',
  devolucionCompra: '➡️ Purchase Return',
  datosDevolucion: '📋 Return details',
  productoDevuelto: 'Returned product',
  cantidadDevuelta: 'Returned quantity',
  accionDevolucion: 'Action to take',
  reembolsoDinero: 'Money refund',
  cambioProducto: 'Exchange for another product',
  perdidaInventario: 'Loss (does not return to inventory)',
  productoNuevo: 'New product for exchange',
  cantidadNuevo: 'New product quantity',
  motivoDevolucion: 'Return reason',
  motivoPlaceholder: 'Eg: Defective product, wrong size, etc.',
  devolucionExitosa: '✅ Return registered successfully',
  productoNuevoRequerido: '❌ You must specify the new product for exchange',
  productoNuevoNoExiste: '❌ The product does not exist in inventory',
  stockInsuficienteNuevo: '❌ Insufficient stock of the new product',
  nombreProductoDevuelto: 'Eg: Men\'s Pants',
  nombreProductoNuevo: 'Eg: Long Sleeve Shirt',
  productoNoExiste: '❌ The product does not exist in inventory'
};

